export enum Encoding {
  UTF8,
  UTF16LE,
  UTF16BE,
  UTF32LE,
  UTF32BE
}

const encodingMap = {
  [Encoding.UTF8]: "utf-8",
  [Encoding.UTF16LE]: "utf-16le",
  [Encoding.UTF16BE]: "utf-16be",
  [Encoding.UTF32LE]: "utf-32le",
  [Encoding.UTF32BE]: "utf-32be"
} as const;

export function getEncodingString(encoding: Encoding): string {
  return encodingMap[encoding];
}
